import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { alpha } from '@mui/material/styles';
import DialogContentText from '@mui/material/DialogContentText';

const PREFIX = 'ConfirmationDialog';

const classes = {
  buttonContainer: `${PREFIX}-buttonContainer`,
  button: `${PREFIX}-button`,
  buttonError: `${PREFIX}-buttonError`,
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.buttonContainer}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBottom: theme.spacing(2),
  },

  [`& .${classes.button}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.buttonError}`]: {
    backgroundColor: alpha(theme.palette.error.main, 0.9),
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    },
  },
}));

interface Props {
  title: string;
  information: string;
  buttons: string[];
  open: boolean;
  confirmationClicked(buttonClicked: string): void;
  warningText?: string;
}

function ConfirmationDialog({
  title,
  information,
  buttons,
  open,
  confirmationClicked,
  warningText,
}: Props) {
  const handleClose = (buttonName: string) => {
    confirmationClicked(buttonName);
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" variant="body1">
          {information}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {buttons.length > 0 &&
          buttons.map((button, index) => (
            <Button
              onClick={() => handleClose(button)}
              color="primary"
              variant={index === 1 ? 'contained' : 'outlined'}
              key={button}
              className={button === warningText ? classes.buttonError : ''}>
              {button}
            </Button>
          ))}
      </DialogActions>
    </StyledDialog>
  );
}

export default ConfirmationDialog;
